import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import searcher from "../../../assets/searchInput.svg";
import { useDispatch } from "react-redux";
import TableContainer from "../../layouts/table-container/table-container";
import ErrorPopup from "../../popups/ErrorPopup";
import ChangeSaved from "../../popups/ChangeSaved";
import CloseIcon from "../../../assets/icons/closeIcon";
import "../bulk-upload/bulk-upload.css";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import Select from "react-select";
import {
  FFCustomersList,
  updateCustomersRM,
} from "../../../redux/actions/fieldForceAction";
import { useParams } from "react-router-dom";
import LoadingSpinnerTable from "../../utilites/loader";

const CustomersTableModal = ({ show, ShowClose, reportingManager }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [fieldForceDoctorsList, setFieldForceDoctorsList] = useState([]);
  const [filteredDoctorsList, setFilteredDoctorsList] = useState([]);
  const [fieldForcePharmacyList, setFieldForcePharmacyList] = useState([]);
  const [filteredPharmacyList, setFilteredPharmacysList] = useState([]);
  const [selectedCustomer, setselectedCustomer] = useState("Doctors");
  const [productVerifiedList, setProductVerifiedList] = useState([]);
  const [checkedPharmaciesList, setCheckedPharmaciesList] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [reassignActive, setReassignActive] = useState(false);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (show) {
      setloading(true);
      dispatch(FFCustomersList({ user_id: params.id }, onSuccess, onError));
    }
  }, [show]);

  const onSuccess = (data) => {
    setloading(false);
    setFieldForceDoctorsList(data.data.data.doctors);
    setFilteredDoctorsList(data.data.data.doctors);
    setFieldForcePharmacyList(data.data.data.pharmacies);
    setFilteredPharmacysList(data.data.data.pharmacies);
  };
  const onError = (err) => {
    setloading(false);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const checkedDoctor = (e, item) => {
    const { checked } = e.target;

    setProductVerifiedList((prevList) => {
      if (checked) {
        return [
          ...prevList,
          {
            ff_user_id: "",
            doctor_id: item.id,
          },
        ];
      } else {
        return prevList.filter((obj) => obj.doctor_id !== item.id);
      }
    });
  };

  const handleDoctorChange = (selectedOption, item) => {
    setProductVerifiedList((prevList) =>
      prevList.map((obj) =>
        obj.doctor_id === item.id
          ? { ...obj, ff_user_id: selectedOption.value }
          : obj
      )
    );
  };

  const checkedPharmacy = (e, item) => {
    const { checked } = e.target;

    setCheckedPharmaciesList((prevList) => {
      if (checked) {
        return [
          ...prevList,
          {
            ff_user_id: "",
            pharmacy_id: item.id,
          },
        ];
      } else {
        return prevList.filter((obj) => obj.pharmacy_id !== item.id);
      }
    });
  };

  const handlePharmacyChange = (selectedOption, item) => {
    setCheckedPharmaciesList((prevList) =>
      prevList.map((obj) =>
        obj.pharmacy_id === item.id
          ? { ...obj, ff_user_id: selectedOption.value }
          : obj
      )
    );
  };

  const searchDoctorHandler = (e) => {
    console.log(e.target.value == "");

    if (e.target.value === "") {
      setFilteredDoctorsList(fieldForceDoctorsList);
    } else {
      let newArr = fieldForceDoctorsList.filter(
        (doctor) =>
          doctor.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
          doctor.code.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setFilteredDoctorsList(newArr);
    }
  };

  const searchPharmacyHandler = (e) => {
    console.log(e.target.value == "");

    if (e.target.value === "") {
      setFilteredPharmacysList(fieldForcePharmacyList);
    } else {
      let newArr = fieldForcePharmacyList.filter(
        (Pharmacy) =>
          Pharmacy.pharmacy_name
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          Pharmacy.code.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setFilteredPharmacysList(newArr);
    }
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };
  const timeOutFnc = () => {
    setShowSuccessPopup(false);
  };

  const updateReportingManagerSubmit = () => {
    dispatch(
      updateCustomersRM(
        {
          ff_user_id: params.id,
          doctors: productVerifiedList,
          pharmacies: checkedPharmaciesList,
        },
        onReportingManagerSuccess,
        onReportingManagerError
      )
    );
  };

  const onReportingManagerSuccess = (data) => {
    ShowClose();
    setReassignActive(false);
    setShowSuccessPopup(true);
    setProductVerifiedList([]);
    setCheckedPharmaciesList([]);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const onReportingManagerError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        dialogClassName="subordinate-data-table-container col-12 px-5 mx-auto"
        size="lg"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <span className="fn_Nunito fw_700 fs_22">
              Customers {reassignActive ? "- Reassign" : ""}
            </span>
            <button className="border-0 bg-white" onClick={() => ShowClose()}>
              <CloseIcon fill="black" width={"14px"} />
            </button>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="m-2 mb-3 row gap-4">
            <AdminButton
              background={
                selectedCustomer === "Doctors" ? "#24D626" : "#B0B3C7"
              }
              color="white"
              width="160px"
              onClick={() => setselectedCustomer("Doctors")}
            >
              <span className="m-2 fw_700 text-uppercase">Doctors</span>
            </AdminButton>
            <AdminButton
              background={
                selectedCustomer === "Pharmacies" ? "#24D626" : "#B0B3C7"
              }
              color="white"
              width="160px"
              onClick={() => setselectedCustomer("Pharmacies")}
            >
              <span className="m-2 fw_700 text-uppercase">Pharmacies</span>
            </AdminButton>
          </div>
          {selectedCustomer === "Doctors" && (
            <div className="modal-table-container">
              <div className="search-container d-flex justify-content-between ">
                <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                  <img className="styled-SVG" src={searcher} color={""} />
                  <input
                    className="search-input fw_400 px-2"
                    type="text"
                    placeholder="Search Doctor here by Doctor Name and Code..."
                    onChange={searchDoctorHandler}
                  />
                </div>
              </div>
              <div
                style={{
                  maxHeight: "60vh",
                  overflow: "auto",
                }}
              >
                <TableContainer>
                  <thead>
                    <tr className="table-rows color_747f9e">
                      {reassignActive && (
                        <th className="table-heads " width={"2%"}></th>
                      )}
                      <th className="table-heads " width={"5%"}>
                        Doctor Code
                      </th>
                      <th className="table-heads " width={"10%"}>
                        Doctor Name
                      </th>
                      <th className="table-heads " width={"7%"}>
                        Customer Type
                      </th>
                      <th className="table-heads " width={"12%"}>
                        Division
                      </th>
                      {reassignActive && productVerifiedList.length > 0 && (
                        <th className="table-heads" width={"15%"}>
                          Assign To
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody style={{ position: "relative" }}>
                    {loading === true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <>
                        {filteredDoctorsList?.map((item, index) => (
                          <tr className="table-rows1" key={index}>
                            {reassignActive && (
                              <td className="table-each-row-data" width={"3%"}>
                                <input
                                  type="checkbox"
                                  className="superCheck"
                                  id={`checkbox-${index}`}
                                  name="prodcutsCheck"
                                  onChange={(e) => checkedDoctor(e, item)} // Pass individual item
                                  checked={productVerifiedList.some(
                                    (obj) => obj.doctor_id === item.id
                                  )}
                                />
                              </td>
                            )}

                            <td className="table-each-row-data">{item.code}</td>
                            <td className="table-each-row-data">{item.name}</td>
                            <td className="table-each-row-data">
                              {item.doctorSubscribedVendors?.length > 0
                                ? item.doctorSubscribedVendors[0]
                                    ?.onboarding_type === "self"
                                  ? "Dispensing"
                                  : item.doctorSubscribedVendors[0]
                                      ?.onboarding_type === "dispensing"
                                  ? "Dispensing"
                                  : item.doctorSubscribedVendors[0]
                                      ?.onboarding_type === "attach"
                                  ? "Attach"
                                  : "--"
                                : "--"}
                            </td>
                            <td className="table-each-row-data">
                              {item.doctorSubscribedVendors?.length > 0
                                ? item.doctorSubscribedVendors?.map(
                                    (ele, index) => {
                                      return (
                                        <span
                                          style={{ whiteSpace: "pre-wrap" }}
                                          key={index}
                                        >
                                          <span style={{ color: "#B0B3C7" }}>
                                            {index ? " | " : ""}
                                          </span>
                                          {ele?.vendorDivision?.name
                                            ? ele?.vendorDivision?.name
                                            : "--"}
                                        </span>
                                      );
                                    }
                                  )
                                : "--"}
                            </td>

                            {reassignActive &&
                              productVerifiedList.some(
                                (obj) => obj.doctor_id === item.id
                              ) && (
                                <td className="table-each-row-data">
                                  <div className="w-100 pe-2">
                                    <Select
                                      options={reportingManager}
                                      styles={customStyles}
                                      placeholder="Select the option"
                                      value={reportingManager?.find(
                                        (manager) =>
                                          manager.value ===
                                          productVerifiedList?.find(
                                            (selectedDoctor) =>
                                              selectedDoctor.doctor_id ===
                                              item.id
                                          ).ff_user_id
                                      )}
                                      onChange={(selectedOption) =>
                                        handleDoctorChange(selectedOption, item)
                                      }
                                    />
                                  </div>
                                </td>
                              )}
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </TableContainer>
              </div>
            </div>
          )}
          {selectedCustomer === "Pharmacies" && (
            <div className="modal-table-container">
              <div className="search-container d-flex justify-content-between ">
                <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                  <img className="styled-SVG" src={searcher} color={""} />
                  <input
                    className="search-input fw_400 px-2"
                    type="text"
                    placeholder="Search Pharmacies here by Pharmacy Name and Code..."
                    onChange={searchPharmacyHandler}
                  />
                </div>
              </div>
              <div style={{ height: "60vh", overflow: "auto" }}>
                <TableContainer>
                  <thead>
                    <tr className="table-rows color_747f9e">
                      {reassignActive && (
                        <th className="table-heads " width={"2%"}></th>
                      )}
                      <th className="table-heads " width={"5%"}>
                        Pharmacy Code
                      </th>
                      <th className="table-heads " width={"10%"}>
                        Pharmacy Name
                      </th>
                      <th className="table-heads " width={"7%"}>
                        Customer Type
                      </th>
                      <th className="table-heads " width={"12%"}>
                        Division
                      </th>
                      {reassignActive && checkedPharmaciesList.length > 0 && (
                        <th className="table-heads" width={"15%"}>
                          Assign To
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {loading === true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <>
                        {filteredPharmacyList?.map((item, index) => (
                          <tr className="table-rows1" key={index}>
                            {reassignActive && (
                              <td className="table-each-row-data" width={"3%"}>
                                <input
                                  type="checkbox"
                                  className="superCheck"
                                  id={`checkbox-${index}`}
                                  name="prodcutsCheck"
                                  onChange={(e) => checkedPharmacy(e, item)} // Pass individual item
                                  checked={checkedPharmaciesList.some(
                                    (obj) => obj.pharmacy_id === item.id
                                  )}
                                />
                              </td>
                            )}

                            <td className="table-each-row-data">{item.code}</td>
                            <td className="table-each-row-data">
                              {item.pharmacy_name}
                            </td>
                            <td className="table-each-row-data">
                              {item.pharmacySubscribedVendors?.length > 0
                                ? item.pharmacySubscribedVendors[0]
                                    ?.onboarding_type === "self"
                                  ? "Independent"
                                  : item.pharmacySubscribedVendors[0]
                                      ?.onboarding_type === "independent"
                                  ? "Independent"
                                  : item.pharmacySubscribedVendors[0]
                                      ?.onboarding_type === "dispensing"
                                  ? "Independent"
                                  : item.pharmacySubscribedVendors[0]
                                      ?.onboarding_type === "attach"
                                  ? "Attach"
                                  : "--"
                                : "--"}
                            </td>

                            <td className="table-each-row-data">
                              {item.pharmacySubscribedVendors?.length > 0
                                ? item.pharmacySubscribedVendors?.map(
                                    (ele, index) => {
                                      return (
                                        <span
                                          style={{ whiteSpace: "pre-wrap" }}
                                          key={index}
                                        >
                                          <span style={{ color: "#B0B3C7" }}>
                                            {index ? " | " : ""}
                                          </span>
                                          {ele?.vendorDivision?.name
                                            ? ele?.vendorDivision?.name
                                            : "--"}
                                        </span>
                                      );
                                    }
                                  )
                                : "--"}
                            </td>

                            {reassignActive &&
                              checkedPharmaciesList.some(
                                (obj) => obj.pharmacy_id === item.id
                              ) && (
                                <td className="table-each-row-data">
                                  <div className="w-100 pe-2">
                                    <Select
                                      options={reportingManager}
                                      styles={customStyles}
                                      placeholder="Select the option"
                                      value={reportingManager?.find(
                                        (manager) =>
                                          manager.value ===
                                          checkedPharmaciesList?.find(
                                            (selectedPharmacy) =>
                                              selectedPharmacy.pharmacy_id ===
                                              item.id
                                          ).ff_user_id
                                      )}
                                      onChange={(selectedOption) =>
                                        handlePharmacyChange(
                                          selectedOption,
                                          item
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              )}
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </TableContainer>
              </div>
            </div>
          )}

          <div className="my-2 mt-4">
            {!reassignActive ? (
              <AdminButton
                background="#7065E4"
                color="white"
                width="180px"
                onClick={() => setReassignActive(true)}
              >
                <span className="m-2 fw_700">REASSIGN</span>
              </AdminButton>
            ) : (
              <div className="d-flex gap-4 justify-content-end">
                <AdminButton
                  background="#FF6F5B"
                  color="white"
                  width="180px"
                  onClick={() => setReassignActive(false)}
                >
                  <span className="m-2">CANCEL</span>
                </AdminButton>
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="180px"
                  onClick={updateReportingManagerSubmit}
                >
                  <span className="m-2 fw_700">CONFIRM</span>
                </AdminButton>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default CustomersTableModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    padding: "0.1rem",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
